var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacemelnegative({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 412,
    height: 600,
    viewBox: "0 0 412 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "face_mel_negative_svg__c",
    d: "M29.695 251.595c0-26.877-10.644-86.29-10.644-86.29C5.05 74.008 68.568 0 160.945 0h26.84c92.366 0 158.217 74.324 147.772 166.097 0 0-6.113 38.891-5.323 63.276-.79 55.878 16.18 61.297 16.18 61.297 4.758 4.313 3.61 9.345-2.581 11.2 0 0-103.62 32.615-159.682 32.615-56.588 0-179.129-33.044-179.129-33.044-6.252-1.636-6.615-5.25-1.055-8.549 0 0 25.728-9.046 25.728-41.297z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_mel_negative_svg__e",
    d: "M.47 42.608V25.54C.47 11.686 11.695.455 25.552.455c13.852 0 25.083 11.239 25.083 25.092v17.061"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_mel_negative_svg__g",
    d: "M.47 42.608V25.54C.47 11.686 11.695.455 25.552.455c13.852 0 25.083 11.239 25.083 25.092v17.061H.469z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_mel_negative_svg__i",
    d: "M0 126.542C0 56.655 56.656 0 126.536 0c69.884 0 126.536 56.657 126.536 126.542v44.411c0 69.888-56.514 130.563-126.217 135.521l-.319.023-.32-.023C56.51 301.515 0 240.84 0 170.954v-44.412z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_mel_negative_svg__k",
    d: "M1.002 8.48S26.767-9.2 58.477 6.5C37.745 29.42 1.002 8.48 1.002 8.48z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "face_mel_negative_svg__a",
    width: 412,
    height: 600,
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_mel_negative_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_mel_negative_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#face_mel_negative_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31 43)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_mel_negative_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_mel_negative_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A4F",
    strokeWidth: 12.6,
    d: "M187.785-6.3c48.106 0 89.267 19.409 117.087 50.68 27.855 31.308 42.391 74.573 36.945 122.43-.036.265-6.061 38.428-5.286 62.359-.563 40.265 8.785 52.477 11.225 54.971l.157.157c.267.26.418.372.418.372s.56.415 1.861.935c.151.129.303.262.453.398 1.94 1.758 3.227 3.622 4.002 5.42 1.072 2.484 1.241 4.93.72 7.188-.517 2.245-1.733 4.37-3.779 6.143-1.474 1.278-3.436 2.398-5.934 3.149-3.055.955-105.635 32.883-161.503 32.883-57.012 0-180.392-33.16-180.768-33.261-2.457-.648-4.303-1.561-5.622-2.528-2.574-1.888-3.67-4.175-3.947-6.418-.27-2.19.213-4.655 2.179-7.13 1.028-1.296 2.577-2.679 4.76-3.974.215-.128.428-.25.638-.365.318-.098.486-.16.486-.16s9.462-3.471 15.8-13.645c3.305-5.304 5.718-12.404 5.718-21.71 0-25.205-9.517-79.394-10.47-84.75l-.048-.273-.028-.156c-7.333-47.808 5.694-90.9 32.48-122.104C72.111 13.108 112.73-6.3 160.944-6.3h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#886653",
    stroke: "#363A4F",
    strokeWidth: 12.6,
    d: "M187.785-6.3c48.106 0 89.267 19.409 117.087 50.68 27.855 31.308 42.391 74.573 36.945 122.43-.036.265-6.061 38.428-5.286 62.359-.563 40.265 8.785 52.477 11.225 54.971l.157.157c.267.26.418.372.418.372s.56.415 1.861.935c.151.129.303.262.453.398 1.94 1.758 3.227 3.622 4.002 5.42 1.072 2.484 1.241 4.93.72 7.188-.517 2.245-1.733 4.37-3.779 6.143-1.474 1.278-3.436 2.398-5.934 3.149-3.055.955-105.635 32.883-161.503 32.883-57.012 0-180.392-33.16-180.768-33.261-2.457-.648-4.303-1.561-5.622-2.528-2.574-1.888-3.67-4.175-3.947-6.418-.27-2.19.213-4.655 2.179-7.13 1.028-1.296 2.577-2.679 4.76-3.974.215-.128.428-.25.638-.365.318-.098.486-.16.486-.16s9.462-3.471 15.8-13.645c3.305-5.304 5.718-12.404 5.718-21.71 0-25.205-9.517-79.394-10.47-84.75l-.048-.273-.028-.156c-7.333-47.808 5.694-90.9 32.48-122.104C72.111 13.108 112.73-6.3 160.944-6.3h0z",
    mask: "url(#face_mel_negative_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M72.395 44.324s8 14 8 18-60 46-21 203 28 71 28 71l72-.043-43-280-44-11.957zM98.395 9.28s214-30 245 119l-34-103-108-42-66 3-37 23z",
    mask: "url(#face_mel_negative_svg__d)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#face_mel_negative_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.596 72.704)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.767,
    cy: 181.092,
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 8.1,
    rx: 32.735,
    ry: 32.779
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.685,
    cy: 179.291,
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 8.1,
    rx: 32.735,
    ry: 32.779
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.9,
    cy: 179.462,
    r: 14,
    fill: "#000",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.076 272.74)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_mel_negative_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_mel_negative_svg__e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 12.6,
    xlinkHref: "#face_mel_negative_svg__e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8CCB8",
    d: "M8.211 12.458S-2.587 46.663 25.308 64.666c27.895 18.002-5.399 17.102-5.399 17.102l-36.893-30.604-.9-33.305L8.21 12.458z",
    mask: "url(#face_mel_negative_svg__f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.076 272.74)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_mel_negative_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_mel_negative_svg__g"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    xlinkHref: "#face_mel_negative_svg__g"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8CCB8",
    d: "M8.211 12.458s38.338 7.855 66.233 25.858c27.895 18.003-54.535 43.452-54.535 43.452l-36.893-30.604-.9-33.305L8.21 12.458z",
    mask: "url(#face_mel_negative_svg__h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.496 .38)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_mel_negative_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_mel_negative_svg__i"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F9CCB6",
    xlinkHref: "#face_mel_negative_svg__i"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9C1B6",
    stroke: "#363A50",
    strokeWidth: 12.6,
    d: "M126.561 6.3c33.192.007 63.241 13.464 84.994 35.218 21.759 21.76 35.217 51.821 35.217 85.024h0v44.411c0 33.323-13.503 64.433-35.279 87.814-21.68 23.278-51.581 38.919-84.642 41.39-33.336-2.47-63.372-18.078-85.128-41.32C19.83 235.449 6.3 204.309 6.3 170.953h0v-44.41c0-32.844 13.168-62.612 34.512-84.313C62.187 20.497 91.761 6.854 124.521 6.317h0z",
    mask: "url(#face_mel_negative_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M23.378 73.388l38-28s176-23 169 66l-4-72-123-46-77 19-3 61zM217.26 168.314l10 31s-4 61.074-85 108l103-66.074 7-46-13-23-22-3.926z",
    mask: "url(#face_mel_negative_svg__j)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M238.462 118.368c-10.853-6.265-26.697.86-35.389 15.915M74.269 116.668c10.852-6.266 26.696.86 35.388 15.914"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 4.234,
    d: "M151.59 186.426s-4.074 18.59.28 22.795c4.354 4.204 15.491-.264 15.491-.264"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 221.81,
    cy: 192.573,
    fill: "#F19797",
    opacity: 0.3,
    rx: 17.547,
    ry: 17.553
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.634,
    cy: 192.573,
    fill: "#F19797",
    opacity: 0.3,
    rx: 17.547,
    ry: 17.553
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.086 139.722)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 47.107,
    x2: 42.607,
    y1: 8.569,
    y2: 12.069,
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.373,
    x2: 35.341,
    y1: 2.905,
    y2: 7.733,
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.111,
    x2: 25.602,
    y1: 0.48,
    y2: 6.158,
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.956,
    x2: 12.8,
    y1: 1.722,
    y2: 7.116,
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.731,
    x2: 5.025,
    y1: 8.544,
    y2: 12.293,
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.137 21.772C11.357 20.881 2.91 16.83 4.27 12.725c1.36-4.105 12.014-6.71 23.794-5.82 11.78.892 18.866 9.048 18.866 9.048s-12.014 6.71-23.794 5.82z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.988,
    cy: 13.91,
    fill: "#363A50",
    rx: 7.554,
    ry: 7.563
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 243.086 141.722)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 47.107,
    x2: 42.607,
    y1: 8.569,
    y2: 12.069,
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.373,
    x2: 35.341,
    y1: 2.905,
    y2: 7.733,
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.111,
    x2: 25.602,
    y1: 0.48,
    y2: 6.158,
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.956,
    x2: 12.8,
    y1: 1.722,
    y2: 7.116,
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.731,
    x2: 5.025,
    y1: 8.544,
    y2: 12.293,
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.137 21.772C11.357 20.881 2.91 16.83 4.27 12.725c1.36-4.105 12.014-6.71 23.794-5.82 11.78.892 18.866 9.048 18.866 9.048s-12.014 6.71-23.794 5.82z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.988,
    cy: 13.91,
    fill: "#363A50",
    rx: 7.554,
    ry: 7.563
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 4.41,
    d: "M21.315 175.919c5.37-3.228 12.338-1.495 15.561 3.87h0c3.223 5.364 1.482 12.329-3.888 15.556"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.67 226.788)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_mel_negative_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_mel_negative_svg__k"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E68794",
    xlinkHref: "#face_mel_negative_svg__k"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E68794",
    d: "M1.002 8.48S26.767-9.2 58.477 6.5C37.745 29.42 1.002 8.48 1.002 8.48z",
    mask: "url(#face_mel_negative_svg__l)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "1.072 8.106 63.844 7.006 7.679 -8.399",
    mask: "url(#face_mel_negative_svg__l)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M117.743 230.296c-.74 0-1.34 1.798-1.34 4.017h0c0 2.22.6 4.018 1.34 4.018M195.422 230.296c.74 0 1.339 1.798 1.339 4.017h0c0 2.22-.6 4.018-1.34 4.018"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 4.41,
    d: "M274.63 168.878c4.728-4.11 11.89-3.614 15.996 1.11h0c4.106 4.722 3.6 11.884-1.128 15.994"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M151.408 183.631s-1.882 20.957 18.043 24.957l-15.074 2-4-6 1.031-20.957z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#886653",
    d: "M163.078 104.503s120.854-3.858 140.896 25.716c20.042 29.574-10.725 87.435 1.944 111.866 12.668 24.43 34.386 27.002 34.386 47.575 0 20.573 6.468-88.355 6.468-88.355l-2.714-46.29-48.865-61.718-65.152-30.86h-94.11L97.926 81.725l24.432 12.858"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 10.8,
    d: "M102.45 84.296s45.881 22.778 67.599 22.778c21.717 0 109.358-6.429 129.4 23.145 20.042 29.574-10.724 87.435 1.944 111.866 12.669 24.43 34.386 27.002 34.386 47.575"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 10.8,
    d: "M342.099 202.366s8.998 34.205-3.6 86.413"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M189.508 377.261s49.043 7 49.043 19l3-25-52.043 6z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacemelnegative);
export default __webpack_public_path__ + "static/media/face.mel.negative.34064837.svg";
export { ForwardRef as ReactComponent };